import WalletEdit from "./WalletEdit";

export default WalletEdit;
